// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3qS-z","vLegacy":"SelectSecondary_vLegacy__1XkQp","error":"SelectSecondary_error__3HwKP","disabled":"SelectSecondary_disabled__2vVkp"};